module.exports = __webpack_public_path__ + "img/30_36.292edcd9.png";